import { Box, listClasses, MenuItem, menuItemClasses, MenuList, Paper, paperClasses, Popover, popoverClasses, Popper, Select, TableCell, tableClasses } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { thirdly4 } from 'styles/theme';
import { primary500, bg } from 'styles/theme';
import { hover } from 'styles/theme';
import { paginationH } from 'styles/theme';
import { toolbarH } from 'styles/theme';
import { tabsH } from 'styles/theme';
import { titleH } from 'styles/theme';

export const LongCellStyles = muiStyled(Box)(({ width, theme }) => ({
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: width || 200,
    whiteSpace: "nowrap",
    '.no-messages': {
        color: "#00000080"
    }
}));

export const HeaderWithBetaStyles = muiStyled(Box)(({ size }) => ({
    display: "flex",
    columnGap: 8,
    alignItems: "center",
    '.beta-chip': {
        display: "flex",
        background: "#E6D9FB",
        borderRadius: 5,
        fontWeight: "normal",
        padding: "0px 8px",
        color: "#6E5DC6",
        fontSize: 14
    }
}))


export const MenuItemOptionStyles = muiStyled(MenuItem)(({ width, theme }) => ({
    '&:hover': {
        backgroundColor: `${hover} !important`, // צבע Hover לבחירתך
    },

    // 3. דריסת מצב Selected (כשזה הערך שנבחר)
    '&.Mui-selected': {
        backgroundColor: `${hover} !important`, // צבע רקע כשנבחר
        color: primary500,          // צבע טקסט כשנבחר

        // 4. דריסת מצב Hover על אלמנט שכבר נבחר (חשוב מאוד!)
        '&:hover': {
            backgroundColor: `${hover} !important`
        },
    },
}))

export const FooterPagintionStyles = muiStyled(Box)(({ width, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px',
    height: 45,
    background: "white",
    '.move-between-pages': {
        display: "flex",
        columnGap: 15,
        alignItems: "center"
    },
    '.current-page-rows': {
        color: "#6C7A90"
    },
    '& .MuiSelect-root': {
        position: 'relative', // מבטיח שהקליק ייתפס
    },

    '& .MuiSelect-icon': {
        pointerEvents: 'none !important', // מבטיח שהקליק עובר דרך האייקון
        right: '7px',
        top: 'calc(50% - 5px)', // מרכוז ידני אם צריך בגלל הגודל הקטן (10px)
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    '& .MuiInputBase-root': {
        // מוודא שה-Select עצמו (השכבה שמתחת) תופסת את כל השטח
        '& .MuiSelect-select': {
            paddingRight: '30px !important', // משאיר מקום לאייקון שלא יסתיר טקסט
        }
    },
    '.rows-number': {
        color: "#6C7A90"
    },
    '.select-rows-number': {
        display: "flex",
        columnGap: 15,
        alignItems: "center"
    },
    '.MuiInputBase-root.MuiInput-root.MuiSelect-root::before': {
        borderBottom: "none"
    },
    '.MuiInputBase-root.MuiInput-root.MuiSelect-root': {
        border: "1px solid #E3E8F0",
        padding: "5px 10px"
    },
    '.MuiMenuItem-root.Mui-selected': {
        '&:hover': {
            background: "red", // שינוי צבע ה-border בריחוף
        },
    },
    '.MuiInputBase-root': {
        border: "1px solid #E3E8F0",
        borderRadius: "6px",
        transition: "all 0.2s ease",

        '&.Mui-focused': {
            borderColor: "#A0AEC0",
            boxShadow: "0 0 0 2px rgba(227, 232, 240, 0.5)", // אפקט פוקוס עדין
        },
        '& .MuiSelect-select': {
            padding: "6px 12px",
            display: "flex",
            alignItems: "center",
        }
    }
}));

export const TableStyles = muiStyled(Paper)(({ isExpanded, nested, flexGrow, bgHead, tableH, hideToolbar, theme, $systemUI, withTitle, withTabs, hidePagination }) => ({
    // height: tableH || `calc(100% - ${hideToolbar ? hidePagination ? 0 : 55 : toolbarH}px - ${withTabs ? tabsH : '0'}px - ${withTitle ? titleH : '0'}px)`,

    height: "100%",
    flexGrow: flexGrow && 1,
    borderRadius: 7,
    boxShadow: "none",
    // '.MuiPaper-root': {
    //     boxShadow: "none"
    // },

    '.table-head': {
        position: "relative",
        zIndex: 100
    },
    '.selected-row': {
        background: "#f6faff"
    },
    '.not-for-execution-row': {
        background: "#FFF5F5"
    },
    '.MuiPaper-root.MuiTableRow-root': {
        background: nested && bg
    },
    '.toolbar-collapse-items': {
        display: "flex",
        justifyContent: "end",
        width: "100%"
    },
    '.MuiToolbar-root': {
        paddingTop: "0px !important",
        display: "flex",
        justifyContent: "space-between"
    },
    '.row-nested': {
        background: `${thirdly4}`
    },
    '.row-with-collapse': {
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            background: '#f0f7ff', // או כל צבע שאת רוצה
        }
    },
    '.MuiTableContainer-root': {
        background: "white",
        borderRadius: 7,
        border: nested ? `2px solid #E2E3E3 !important` : "none",
        height:
            hidePagination ? "100%" :
                (isExpanded ? "calc(100% - 220px)" : "calc(100% - 154px)")
        // height: tableH || `calc(100% - ${hidePagination ? 0 : paginationH}px - ${hideToolbar ? 0 : toolbarH}px)`
    },
    '.MuiTablePagination-root': {
        height: paginationH,
        background: "white"
    },
    '.MuiTablePagination-actions': {
        transform: "rotate(180deg)",
        direction: "rtl"
    },
    '.toolbar-system-items': {
        display: "flex",
        columnGap: 10
    },
    '.MuiButtonBase-root.MuiTableSortLabel-root': {
        whiteSpace: "nowrap !important"
    },
    '.MuiDataGrid-footerContainer': {
        display: hidePagination && 'none'
    },
    '.MuiTable-root': {
        // border: `1px solid ${thirdly3} !important`
    },
    '.MuiTableCell-root': {
        padding: "10px 15px",
        fontSize: 16,
        whiteSpace: "nowrap",
        [theme.breakpoints.down('md')]: {
            whiteSpace: "nowrap"
        },
    },
    '.nested-table': {
        marginBottom: 20
    },
    '.MuiTableCell-root.MuiTableCell-head.MuiTableCell-stickyHeader.MuiTableCell-sizeMedium': {
        background: bgHead && "#FBFBFB",
        fontWeight: "bold"
    },
    '.head-cell': {
        [theme.breakpoints.down('md')]: {
            // minWidth: 110,
            whiteSpace: "nowrap"
        }
    }
}));


export const TableCellStyles = muiStyled(TableCell)(({ alignCenter, collapse, hideBorder }) => ({
    borderBottom: (hideBorder || collapse) ? "none" : "1px solid rgba(224, 224, 224, 1)",
    textAlign: alignCenter && "center",
    '.collapse-loading': {
        display: "flex",
        justifyContent: "center"
    },
    '.invalid-cell': {
        color: "#FF0000"
    }
}));

export const CopyItemCellStyles = muiStyled(Box)(({ alignCenter, theme, $systemUI, hidePagination }) => ({
    display: "flex",
    alignItems: "center",
    columnGap: 5,
    '.email-and-icon': {
        display: "flex",
        alignItems: "center"
    }
}));

export const ToolbarColumnStyles = muiStyled(Box)(({ theme, $systemUI, hidePagination }) => ({
    [popoverClasses.root]: {
        zIndex: "1300 !important",
        background: "beige"
    },
    [popoverClasses.paper]: {
        zIndex: "1300 !important",
        background: "beige",
    }
}));

export const CellWithTooltipStyles = muiStyled(Box)(({ blurred }) => ({
    whiteSpace: "nowrap",
    filter: blurred && "blur(4.5px)"
}));

export const ImageCellStyles = muiStyled(Box)(({ size }) => ({
    width: 30,
    height: 30,
}));

export const PopperStyles = muiStyled(Popper)(({ }) => ({
    zIndex: 10000,
    width: 240,
    [paperClasses.root]: {
        height: "100% !important"
    }
}));


export const MenuStyles = muiStyled(MenuList)(({ theme, $systemUI, hidePagination }) => ({
    maxHeight: 400,
    overflow: "auto",
    '.MuiMenuItem-root': {
        height: "35px !important"
    }
}));

export const PaperStyles = muiStyled(Paper)(({ theme, $systemUI, hidePagination }) => ({
    borderRadius: 15,
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 18.2px 0px",
    border: "1px solid #CBE1FF"
}));


// const WrapDataGridTable = styled(DataGrid)`
// flex-grow: 1;
// background:${white} !important;
// border: 1px solid ${thirdly3} !important;

// // ${Scroll};
// //  overflow: auto !important;



// .MuiDataGrid-columnHeader:focus .MuiDataGrid-cell:focus{
// // .MuiDataGrid-root .MuiDataGrid-cell:focus-within {
//     outline: none !important;
// }

// `
